import { api, URLs } from '@/libs/api'
import type {
  ApiResponse,
  ChangePasswordPayload,
  LoginHistoryEntry,
  LoginHistoryResponse,
  UserProfile,
} from '@/libs/interfaces'
import { accountApiMock } from '@/libs/mocks/handlers/account'

const accountApiReal = {
  getProfile: async (orgID: string, userID: string): Promise<UserProfile> => {
    return await api
      .get<ApiResponse<UserProfile>>(URLs.Users.byID(orgID, userID))
      .then((response) => response.data.data)
  },

  updateProfile: async (userID: string, data: Partial<UserProfile>): Promise<UserProfile> => {
    return await api
      .patch<ApiResponse<UserProfile>>(URLs.Users.update(userID), data)
      .then((response) => response.data.data)
  },

  changePassword: async (userID: string, payload: ChangePasswordPayload): Promise<void> => {
    await api.patch(URLs.Users.changePassword(userID), payload)
  },

  getLoginHistory: async (orgID: string, userID: string): Promise<LoginHistoryEntry[]> => {
    return await api
      .get<LoginHistoryResponse>(URLs.Users.loginHistory(orgID, userID))
      .then((response) => response.data.data.history ?? [])
  },
}

export const accountApi: typeof accountApiReal = __IS_MOCK_MODE__ ? accountApiMock : accountApiReal
